import { AbstractControl, ValidationErrors } from '@angular/forms';

import { instanceOfPassengerDto } from '../_models/passenger-dto.model';
import { isEmptyInputValue } from '@sd-portal/shared/shell';
export function passengerDtoValidator(control: AbstractControl): ValidationErrors | null {
  // ignore if empty
  if (isEmptyInputValue(control.value)) {
    return null;
  }

  if (typeof control.value === 'object' && instanceOfPassengerDto(control.value)) {
    return null;
  } else {
    return { invalidPassenger: true };
  }
}
